import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { PlanSection } from '../PlanSection/PlanSection';
import { ObjectiveBlock } from './components/ObjectiveBlock';
import { OBJECTIVES_DATA } from './consts';

export function ObjectivesSection() {
  const { t } = useTranslation('campaign-planner');

  const { control } = useFormContext();

  return (
    <PlanSection
      title={t('digitalCampaigns.planWizard.sections.objectives.title')}
      description={t(
        'digitalCampaigns.planWizard.sections.objectives.description',
      )}
    >
      <Controller
        name="objectives"
        control={control}
        defaultValue={[]}
        render={({ field }) => (
          <div className="flex flex-wrap gap-lg">
            {OBJECTIVES_DATA.map((item) => {
              const currentValues = field.value || [];
              const isSelected = currentValues.includes(item.id);

              return (
                <ObjectiveBlock
                  key={item.id}
                  data-testid={`objective-block-${item.id}`}
                  iconName={item.icon}
                  title={t(item.titleKey)}
                  description={t(item.descriptionKey)}
                  isSelected={isSelected}
                  onClick={() => {
                    const newValues = isSelected
                      ? currentValues.filter((id: string) => id !== item.id)
                      : [...currentValues, item.id];

                    field.onChange(newValues);
                  }}
                />
              );
            })}
          </div>
        )}
      />
    </PlanSection>
  );
}

ObjectivesSection.displayName = 'ObjectivesSection';
